import { render } from "./Parternship.vue?vue&type=template&id=dc904370&scoped=true"
import script from "./Parternship.vue?vue&type=script&lang=js"
export * from "./Parternship.vue?vue&type=script&lang=js"

import "./Parternship.vue?vue&type=style&index=0&id=dc904370&lang=scss&scoped=true"
import "./Parternship.vue?vue&type=style&index=1&id=dc904370&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc904370"]])

export default __exports__